import { removeToken } from './token'
import { getLoginPath } from '../../../utils'
import { removeLocalLoginType } from '../../../core/loginType'
/**
 * 跳转去登录
 */
export const toLogin = () => {
  removeLocalLoginType()
  location.href = getLoginPath()
}

/**
 * 跳转去退出登录
 */
export function toSignOut() {
  removeToken()
  toLogin()
}